import { Goal } from '@/api/generated/model';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function calculateDaysRemainingStr(dueDateStr: string): number {
  return calculateDaysRemaining(new Date(dueDateStr));
}

export function calculateDaysRemaining(dueDate: Date): number {
  const today = new Date();
  return Math.ceil((dueDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

export const getGoalProgress = (goal: Goal): number => {
  return (goal.currentAmount / goal.targetAmount) * 100;
};

export const getGoalStatus = (goal: Goal): 'onTrack' | 'atRisk' | 'behind' => {
  const progress = getGoalProgress(goal);
  const dueDate = new Date(goal.dueDate);

  if (progress >= 100) return 'onTrack';
  const daysRemaining = calculateDaysRemaining(dueDate);
  if (daysRemaining <= 0) return 'behind';

  // Calculate if on track based on progress vs time elapsed
  const expectedProgress = 100 - (daysRemaining / 365) * 100;
  if (progress >= expectedProgress - 10) return 'onTrack';
  if (progress >= expectedProgress - 25) return 'atRisk';
  return 'behind';
};

export const formatDate = (date: string): string => {
  const inputDate = new Date(date);
  const today = new Date();

  // Check if the date is today
  const isToday = inputDate.toDateString() === today.toDateString();
  const currentYear = inputDate.getFullYear() === today.getFullYear();

  if (isToday) {
    // For today, show only time in 24-hour format
    return inputDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } else if (currentYear) {
    return inputDate.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } else {
    return inputDate.toLocaleDateString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  }
};
